// extracted by mini-css-extract-plugin
export default {"price":"J6-z","onSale":"K6-z","msrpLabelPrice":"L6-z","msrpLabel":"M6-z","originalPrice":"N6-z","percentOff":"O6-z"};